export const getExternalUrl = url => {
  return `${url.includes('http') ? '' : '//'}${url}`
}
